module.exports = __webpack_public_path__ + "img/expired.674e8ba5.png";